import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const toast = inject(ToastService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Log out and return to sign-in (auth/ endpoints return 401 for bad credentials and handle it themselves)
      if (error.status === 401 && !req.url.includes('auth/')) {
        auth.clearSession();
      }

      // Account locked
      if (error.status === 423) {
        router.navigate(['/portal/account-locked']);
        return throwError(() => error);
      }

      const problem = error.error;
      const summary = problem?.title ?? 'Error';
      const detail = problem?.detail ?? error.message ?? 'Something went wrong';
      toast.error(detail, summary);

      return throwError(() => error);
    }),
  );
};
